export default interface Pagination {
  _links?: {
    self?: { href: string };
    first?: { href: string };
    last?: { href: string };
    prev?: { href: string };
    next?: { href: string };
  };
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentPage: number;
}

export interface PaginatedItems<T> extends Pagination {
  items: T[];
}

export const defaultPagination: Pagination = {
  totalItems: 0,
  itemsPerPage: 1,
  totalPages: 1,
  currentPage: 1,
};
